import { Component, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent {
  header: string;
  content: string;
  minimize: Function;
  hide: Function;
  footer = false;
  submitLabel = 'Yes';
  cancelLabel = 'No';
  onSubmit = new EventEmitter();
}
